/* eslint-disable unicorn/filename-case */
import z from "zod";

export const productionExport = z.object({
    id: z.number(),
    additional_order_data_enabled: z.boolean(),
    additional_order_data_file_format: z.string(),
    automatic_export_enabled: z.boolean(),
    created_at: z.string(),
    notify_after_parcel_ready: z.boolean(),
    order_data_layout: z.string(),
    production_id: z.number(),
    production_production_methods: z.array(
        z.object({
            id: z.number(),
            activated_at: z.string(),
            available_export_file_formats: z.array(
                z.object({
                    name: z.string(),
                    display_name: z.string(),
                }),
            ),
            created_at: z.string(),
            export_file_format: z.nullable(z.string()),
            has_presorting: z.boolean(),
            is_using_presorting: z.boolean(),
            production_id: z.number(),
            production_method: z.object({
                id: z.number(),
                description: z.string(),
                display_name: z.string(),
                information_digitalizer: z.nullable(z.string()),
                information_producer: z.nullable(z.string()),
                is_available: z.boolean(),
                is_digitizable: z.boolean(),
                production_areas_count: z.nullable(z.number()),
                production_type: z.object({
                    id: z.number(),
                    name: z.string(),
                }),
            }),
            production_method_handle: z.string(),
            updated_at: z.string(),
        }),
    ),
    remote_storage: z.nullable(z.any()),
    updated_at: z.string(),
});

export const productionExportResponse = z.union([
    z.array(z.unknown()).max(0),
    productionExport,
]);

export const updateProductionExportSchema = z.object({
    additional_order_data_enabled: z.boolean(),
    additional_order_data_file_format: z.string(),
    automatic_export_enabled: z.boolean(),
    notify_after_parcel_ready: z.boolean(),
    order_data_layout: z.string(),
    production_production_methods: z.array(
        z.object({
            id: z.number(),
            export_file_format: z.string(),
        }),
    ),
});

export type ProductionExport = z.infer<typeof productionExport>;
export type ProductionExportResponse = z.infer<typeof productionExportResponse>;

export const productionMethodsSchema = z.object({
    data: z.array(
        z.object({
            id: z.number(),
            activated_at: z.string(),
            available_export_file_formats: z.array(
                z.object({
                    name: z.string(),
                    display_name: z.string(),
                }),
            ),
            created_at: z.string(),
            export_file_format: z.nullable(z.string()),
            has_presorting: z.boolean(),
            is_using_presorting: z.boolean(),
            notify_after_parcel_ready: z.boolean(),
            production_id: z.number(),
            production_method: z.object({
                id: z.number(),
                description: z.string(),
                display_name: z.string(),
                information_digitalizer: z.string(),
                information_producer: z.string(),
                is_available: z.boolean(),
                is_digitizable: z.boolean(),
                production_areas_count: z.number(),
                production_type: z.object({
                    id: z.number(),
                    name: z.string(),
                }),
            }),
            production_method_handle: z.string(),
            updated_at: z.string(),
        }),
    ),
    links: z.object({
        first: z.nullable(z.string()),
        last: z.nullable(z.string()),
        next: z.nullable(z.string()),
        prev: z.nullable(z.string()),
    }),
    meta: z.object({
        next_cursor: z.nullable(z.string()),
        path: z.string(),
        per_page: z.number(),
        prev_cursor: z.nullable(z.string()),
    }),
});
